import { CheckOutlined } from '@ant-design/icons'
import { addUserByRole, addUserFieldsData, fetchStudentsClassList, fetchStudentsWRTCourseType, fetchAutocompleteCoursesList, fetchCourseBatches, assignNewStudentToSection } from 'actions/userManagementV2'
import { Checkbox, Col, Input, Modal, Row, Select } from 'antd'
import { Button } from 'components/Button'
import { Heading } from 'components/Typography'
import { sanitizeName } from 'components/UserDashboardV2/utils/formatters'
import { IMG_URL } from "env.json"
import { EditImage, ImageComponent } from 'pages/profile/subComponents'
import React, { useEffect, useRef, useState } from 'react'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import PhoneCountrySelect from 'components/PhoneCountrySelect';
import { connect } from 'react-redux'
import { Notification, attendanceCodeError, BIOMETRIC_ENABLED } from 'services'
const defaultImg = require("../../../Assets/Icon awesome-user-alt.svg").default

const { Option } = Select;

const AddUser = ({ open, onCancel, addUserByRole, addUserFieldsData, addUserFields, classList, user, fetchStudentsWRTCourseType, autocompleteCoursesData, fetchAutocompleteCoursesList, getDashboard, userObj, fetchCourseBatches, assignNewStudentToSection }) => {

        const isStaffSection = userObj?.userRole === 'Teachers' || userObj?.userRole === 'Data Operators' || userObj?.userRole === 'Operations';
        const roles = window.location.pathname === "/user/staff" ? ['Teacher', 'Data Operator', 'Operations'] : ['Student', 'Teacher', 'Data Operator', 'Operations'];

        const [buttonLoader, toggleButtonLoader] = useState(false);
        const [isAdminSelected, setIsAdminSelected] = useState(false);
        const [isPlannerSelected, setIsPlannerSelected] = useState(false);
        const [editProfileModal, setEditProfileModal] = useState(false);
        const [deleteConfirmation, setdeleteConfirmation] = useState(false);
        // a live course also takes a batch and section, as in Pick a course
        const [selectedCourseOption, setSelectedCourseOption] = useState(null);
        const [isLiveCourse, setIsLiveCourse] = useState(false);
        const [courseBatches, setCourseBatches] = useState({});
        const [selectedBatch, setSelectedBatch] = useState(null);
        const [selectedSection, setSelectedSection] = useState(null);
        const sectionsOfSelectedBatch = selectedBatch ? (courseBatches?.[selectedBatch] || []) : [];


        const fillTheDetails = addUserFields?.role == '' || addUserFields?.role == undefined || addUserFields?.name?.trim() == '' || addUserFields?.phone == '' || addUserFields?.phone == undefined || addUserFields?.phone == null;
        const inputProfilePic = useRef();

        const codeLabel = addUserFields?.role === 'Student' ? 'Student code' : 'Employee code';
        // the device identifies a user by their code, so enrolling without one is not possible
        const codeMissingForBiometric = !!addUserFields?.registerBiometric && !addUserFields?.attendanceEmpCode?.trim();
        const codeFormatError = attendanceCodeError(addUserFields?.attendanceEmpCode);

        const resetFields = (role = '') => {
                addUserFieldsData('role', role);
                addUserFieldsData('file', '');
                addUserFieldsData('phone', null);
                addUserFieldsData('email', '');
                addUserFieldsData('course', null);
                addUserFieldsData('name', '');
                addUserFieldsData('privilage', []);
                addUserFieldsData('attendanceEmpCode', '');
                addUserFieldsData('registerBiometric', false);
        };

        // course, batch and section belong to one student choice, so they are cleared together
        const clearCourseSelection = () => {
                addUserFieldsData('course', null);
                addUserFieldsData('courseType', '');
                setSelectedCourseOption(null);
                setIsLiveCourse(false);
                setCourseBatches({});
                setSelectedBatch(null);
                setSelectedSection(null);
        };

        const callback = (res) => {
                console.log(res, "mcres");
                if (res !== undefined) {
                        // The user is created either way; enrolment is reported separately so a
                        // device failure is visible rather than silently swallowed.
                        if (res?.biometric && res.biometric.enrolled === false) {
                                Notification.error('Error', res.biometric.message);
                        }
                        resetFields();
                        clearCourseSelection();

                        onCancel();
                }
                toggleButtonLoader(false);
                // onCancel();
        }

        // the created user comes back nested at res.user.user; put them in the picked section before closing
        const onUserAdded = (res) => {
                const newUserId = res?.user?.user?.id ?? res?.user?.id;
                if (res !== undefined && isLiveCourse && selectedSection && newUserId) {
                        assignNewStudentToSection(newUserId, selectedSection, () => callback(res));
                        return;
                }
                callback(res);
        }

        useEffect(() => {
                let defaultRole = '';
                if (window.location.pathname === "/user-management/courses") {
                        defaultRole = 'Student';
                } else if (window.location.pathname === "/user-management") {
                        defaultRole = '';
                } else if (userObj?.userRole === 'Teachers') {
                        defaultRole = 'Teacher';
                } else if (userObj?.userRole === 'Data Operators') {
                        defaultRole = 'Data Operator';
                } else if (userObj?.userRole === 'Operations') {
                        defaultRole = 'Operations';
                }
                resetFields(defaultRole);
        }, []);

        // a role change starts the course choice over, so a student never inherits an earlier one
        useEffect(() => {
                clearCourseSelection();
        }, [addUserFields?.role]);

        useEffect(() => {
                if (!autocompleteCoursesData?.length || addUserFields?.role == 'Student') {
                        fetchAutocompleteCoursesList({ emptySearch: true, names: true, fromCourse: true }, () => { })
                }
        }, [addUserFields?.role]);

        // if Admin is selected from the privilege list then, Planner and Institute support checkboxes get ticked and disables. 
        // useEffect(() => {
        //         if (addUserFields?.privilage?.includes("Admin")) {
        //                 setIsAdminSelected(true);
        //                 if (addUserFields?.privilage?.indexOf("Planner") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("Planner"), 1);
        //                 }
        //                 if (addUserFields?.privilage?.indexOf("InstituteSupport") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("InstituteSupport"), 1);
        //                 }
        //                 if (addUserFields?.privilage?.indexOf("AttendanceMarker") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("AttendanceMarker"), 1);
        //                 }
        //         } else {
        //                 setIsAdminSelected(false);
        //         }
        // }, [addUserFields?.privilage]);
        useEffect(() => {
    let privileges = [...(addUserFields?.privilage || [])];

    const isAdmin = privileges.includes("Admin");
    const isPlanner = privileges.includes("Planner");

    setIsAdminSelected(isAdmin);
    setIsPlannerSelected(isPlanner);

    // Admin → remove conflicting privileges
    if (isAdmin) {
        privileges = privileges.filter(
            item =>
                item !== "Planner" &&
                item !== "InstituteSupport" &&
                item !== "AttendanceMarker"
        );
    }

    // Planner → remove AttendanceMarker
    if (isPlanner) {
        privileges = privileges.filter(
            item => item !== "AttendanceMarker"
        );
    }

    if (
        JSON.stringify(privileges) !==
        JSON.stringify(addUserFields?.privilage)
    ) {
        addUserFieldsData("privilage", privileges);
    }
}, [addUserFields?.privilage]);

        const onChange = (checkedValues) => {
                addUserFieldsData('privilage', checkedValues);
        }



        const handleAddClick = () => {
                if (fillTheDetails) {
                        Notification.error('Error', 'Please fill all the mandatory details');
                } else if (
                        !isValidPhoneNumber(addUserFields?.phone || '')
                ) {
                        Notification.error('Please enter a valid mobile number');
                } else if (codeMissingForBiometric) {
                        Notification.error('Error', `Please enter the ${codeLabel.toLowerCase()} to register on the biometric device`);
                } else if (codeFormatError) {
                        Notification.error('Error', codeFormatError);
                } else {
                        toggleButtonLoader(true);
                        addUserByRole(onUserAdded, null);
                        fetchStudentsWRTCourseType(null, callback)
                        let params = {
                                userType: 'Student',
                                status: 'Approved',
                                limit: 10
                        };
                        getDashboard(params, () => { })



                };
        };

        const onDeleteConfirm = (callback, successCallback) => {
                callback()
                setImageRemove(false)
                successCallback()
        }

        const handleProfileModalOk = () => {
                setEditProfileModal(false);
                setImageRemove(true)
                inputProfilePic?.current?.click();
        };

        const [imageRemove, setImageRemove] = useState(false)

        return (
                <div>
                        <Modal
                                centered
                                closable
                                open={open}
                                footer={null}
                                className='modal-round-corner'
                                onCancel={onCancel}
                        >
                                <div className='p-20'>
                                        <center>
                                                <Heading>Add a user</Heading>
                                        </center>
                                        <center className='' style={{ marginTop: -20, marginBottom: -25 }}>

                                                <ImageComponent
							userProfileDetails={{ name: addUserFields?.name }}
                                                        src={addUserFields?.photo ? addUserFields?.photo : 'default.png'}
                                                        onChange={() => { }}
                                                        handleEditModal={setEditProfileModal}
                                                        ref={inputProfilePic}
                                                        imageRemove={imageRemove}
                                                        defaultImg={defaultImg}
                                                        setfileInputValue={(file) => { addUserFieldsData('file', file) || 'default.png' }}
                                                />
                                        </center>

                                        <div style={{ float: 'left', fontWeight: 500, }}>Role <span style={{ color: 'red' }}>*</span></div>
                                        {window.location.pathname === "/user-management/courses" ? (
                                                <div className="ant-input ant-input-disabled" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fafafa', color: '#636363', cursor: 'not-allowed' }}>Student</div>
                                        ) : (
                                                <Select value={addUserFields?.role || undefined} onChange={(value) => addUserFieldsData('role', value)} style={{ width: '100%' }} placeholder='Select role'>
                                                        {roles?.map((role, index) => (
                                                                <Option value={role} key={index}>{role}</Option>
                                                        ))}
                                                </Select>
                                        )}

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Name <span style={{ color: 'red' }}>*</span></div>
                                        <Input style={{ width: '100%' }} value={addUserFields?.name} placeholder='Enter name' onChange={(e) => addUserFieldsData('name', sanitizeName(e.target.value))} />

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Mobile number <span style={{ color: 'red' }}>*</span></div>
                                        <PhoneInput value={addUserFields?.phone} onChange={(e) => addUserFieldsData('phone', e)} className="PhoneInputBa" defaultCountry="IN" countrySelectComponent={PhoneCountrySelect} placeholder='Enter mobile number' height={"40px"} style={{ width: '100%' }} maxLength={(addUserFields?.phone?.startsWith('+91') || addUserFields?.phone?.startsWith('91')) && addUserFields?.phone?.length == 13 ? 11 : ""} />

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Email ID</div>
                                        <Input value={addUserFields?.email} style={{ width: '100%' }} onChange={(e) => addUserFieldsData('email', e.target.value)} />

                                        {BIOMETRIC_ENABLED ? (
                                        <>
                                        <div style={{ clear: 'both', paddingTop: 20 }}>
                                                <Checkbox
                                                        checked={!!addUserFields?.registerBiometric}
                                                        onChange={(e) => addUserFieldsData('registerBiometric', e.target.checked)}
                                                >
                                                        Register on biometric device
                                                </Checkbox>
                                        </div>

                                        <div style={{ clear: 'both', float: 'left', fontWeight: 500, marginTop: 20 }}>
                                                {codeLabel} {addUserFields?.registerBiometric ? <span style={{ color: 'red' }}>*</span> : null}
                                        </div>
                                        <Input
                                                value={addUserFields?.attendanceEmpCode}
                                                style={{ width: '100%' }}
                                                maxLength={8}
                                                placeholder={`Enter ${codeLabel.toLowerCase()} e.g. 2026091`}
                                                onChange={(e) => addUserFieldsData('attendanceEmpCode', e.target.value)}
                                        />
                                        {codeMissingForBiometric ?
                                                <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>
                                                        {codeLabel} is required to register on the biometric device
                                                </div>
                                                : codeFormatError ?
                                                        <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>
                                                                {codeFormatError}
                                                        </div>
                                                        : null}
                                        </>
                                        ) : null}
                                        {addUserFields?.role == 'Student' ?
                                                <>
                                                        <div className='m-t-12' style={{ fontWeight: 500 }}>Course</div>
                                                        <Select value={selectedCourseOption ?? undefined} onChange={(val) => {
                                                                setSelectedCourseOption(val);
                                                                const course = autocompleteCoursesData?.find((item) => item?.id == val);
                                                                if (course) {
                                                                        addUserFieldsData('course', course.itemId);
                                                                        addUserFieldsData('courseType', course.type || '');
                                                                }
                                                                const live = course?.itemType === 'course';
                                                                setIsLiveCourse(live);
                                                                setCourseBatches({});
                                                                setSelectedBatch(null);
                                                                setSelectedSection(null);
                                                                if (live) {
                                                                        fetchCourseBatches(course.itemId, (batches) => setCourseBatches(batches || {}));
                                                                }
                                                        }}
                                                                placeholder='Select a course'
                                                                style={{ width: '100%' }}
                                                        >
                                                                {/* a live course is only assignable once it has a batch to join */}
                                                                {autocompleteCoursesData?.filter((item) => item?.itemType !== 'course' || parseInt(item?.standardCount) > 0)?.map((item) => {
                                                                        return <Option key={item?.id} value={item?.id}>{item?.name}</Option>
                                                                })}
                                                        </Select>
                                                        {isLiveCourse &&
                                                                <>
                                                                        <div className='m-t-12' style={{ fontWeight: 500 }}>Batch <span style={{ color: 'red' }}>*</span></div>
                                                                        <Select
                                                                                placeholder='Select a batch'
                                                                                notFoundContent='No batches found'
                                                                                style={{ width: '100%' }}
                                                                                value={selectedBatch}
                                                                                onChange={(value) => { setSelectedBatch(value); setSelectedSection(null); }}
                                                                        >
                                                                                {Object.keys(courseBatches)?.map((batchName) => (
                                                                                        <Option key={batchName} value={batchName}>{batchName}</Option>
                                                                                ))}
                                                                        </Select>
                                                                        <div className='m-t-12' style={{ fontWeight: 500 }}>Section <span style={{ color: 'red' }}>*</span></div>
                                                                        <Select
                                                                                placeholder='Select a section'
                                                                                notFoundContent='No sections found'
                                                                                style={{ width: '100%' }}
                                                                                value={selectedSection}
                                                                                disabled={!selectedBatch}
                                                                                onChange={(value) => setSelectedSection(value)}
                                                                        >
                                                                                {sectionsOfSelectedBatch?.map((item) => (
                                                                                        <Option key={item?.id} value={item?.id}>{item?.section}</Option>
                                                                                ))}
                                                                        </Select>
                                                                </>
                                                        }
                                                </>
                                                :
                                                <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                        <Checkbox.Group
                                                                style={{ width: "100%", fontFamily: "Roboto" }}
                                                                onChange={onChange}
                                                                value={addUserFields?.privilage}
                                                        >
                                                                <Row>
                                                                        <Col style={{ marginBottom: "20px" }} span={8}>
                                                                                <Checkbox disabled={user?.privilage?.includes("Admin") && !user?.privilage?.includes("SuperAdmin") ? true : false}
                                                                                        value="Admin"
                                                                                >
                                                                                        Admin
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox checked={isAdminSelected} disabled={isAdminSelected} value="Planner">
                                                                                        Planner
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        disabled={false}
                                                                                        value="FeeManager"
                                                                                >
                                                                                        Fee manager
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        checked={isAdminSelected}
                                                                                        disabled={isAdminSelected}
                                                                                        value="InstituteSupport"
                                                                                >
                                                                                        Institute support
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col
                                                                                style={{ display: "block" }}
                                                                                span={8}
                                                                        >
                                                                                <Checkbox
                                                                                        checked={isAdminSelected}
                                                                                        disabled={isAdminSelected || isPlannerSelected}
                                                                                        value="AttendanceMarker"
                                                                                >
                                                                                        Attendance marker
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        value="LeaveManager"
                                                                                        disabled={false}
                                                                                >
                                                                                        Leave Manager
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        value="Marketing"
                                                                                >
                                                                                        Marketing
                                                                                </Checkbox>
                                                                        </Col>
                                                                </Row>
                                                        </Checkbox.Group>
                                                </div>
                                        }

                                        <center className='m-t-20'>
                                                <Button disabled={fillTheDetails || codeMissingForBiometric || !!codeFormatError || (addUserFields?.role == 'Student' && isLiveCourse && !selectedSection)} loading={buttonLoader} type='primary' onClick={() => handleAddClick()}>ADD</Button>
                                        </center>
                                </div>
                        </Modal>
                        {editProfileModal &&
                                <EditImage
                                        imageUrl={addUserFields?.file?.name || 'default.png'}
                                        onEditCancel={() => setEditProfileModal(false)}
                                        editModalVisible={editProfileModal}
                                        handleEditOk={handleProfileModalOk}
                                        deleteConfirm={() => {
                                                setdeleteConfirmation(true), setEditProfileModal(true);
                                        }}
                                        deleteModalVisible={deleteConfirmation}
                                        onDeleteCancel={() => setdeleteConfirmation(false)}
                                        setEditProfileModal={setEditProfileModal}
                                        setdeleteConfirmation={setdeleteConfirmation}
                                        addUserFieldsData={addUserFieldsData}
                                        setImageRemove={setImageRemove}
                                        onDeleteConfirm={(callback, successCallback) => onDeleteConfirm(callback, successCallback)}
                                />
                        }
                </div>
        )
}

const mapStateToProps = (state) => {
        const { user } = state.session;
        const { classList, addUserFields, autocompleteCoursesData, userObj } = state.userManagementV2;
        return { classList, addUserFields, autocompleteCoursesData, userObj }
};

const mapDispatchToProps = (dispatch) => ({
        addUserFieldsData: (key, val) => dispatch(addUserFieldsData(key, val)),
        fetchStudentsWRTCourseType: (params, callback) => dispatch(fetchStudentsWRTCourseType(params, callback)),
        addUserByRole: (callback, successCallBack) => dispatch(addUserByRole(callback, successCallBack)),
        fetchStudentsClassList: (params, callBack) => dispatch(fetchStudentsClassList(params, callBack)),
        fetchAutocompleteCoursesList: (params, callBack) => dispatch(fetchAutocompleteCoursesList(params, callBack)),
        fetchCourseBatches: (courseId, callBack) => dispatch(fetchCourseBatches(courseId, callBack)),
        assignNewStudentToSection: (userId, standardId, callback) => dispatch(assignNewStudentToSection(userId, standardId, callback)),
});



export default connect(mapStateToProps, mapDispatchToProps)(AddUser)